import { Badge } from '@/components/ui/badge';
import { STATUS_LABELS } from '@/lib/science/labels';
import type { TrialStatus } from '@/lib/science/types';

const VARIANT: Record<TrialStatus, 'outline' | 'primary' | 'accent-brand'> = {
  planned: 'outline',
  laid: 'outline',
  closed_yield: 'primary',
  // «Требует внимания» (статусный янтарь, не CTA): урожайности нет.
  closed_incomplete: 'accent-brand',
};

/** Статус опыта на языке агронома (Заложен · Закрыт с урожайностью · …). */
export function TrialStatusBadge({
  status,
  label,
}: {
  status: TrialStatus | null | undefined;
  label?: string | null;
}) {
  if (!status) return <span className="text-muted-foreground">—</span>;
  return (
    <Badge variant={VARIANT[status]} className="whitespace-nowrap">
      {label || STATUS_LABELS[status]}
    </Badge>
  );
}
